import React, { useEffect, useState } from "react";
import { MapPin } from "lucide-react";
import api from "@/lib/api";

const STATUSES = ["new", "shortlisted", "posted", "archived"];
const pill = { new: "bg-[#FFD93D]/40 text-[#19324A]", shortlisted: "bg-[#4CC9F0]/20 text-[#0E7490]", posted: "bg-[#7ED957]/25 text-[#166534]", archived: "bg-[#19324A]/8 text-[#19324A]/50" };

export default function PlaceSuggestionsCard() {
  const [d, setD] = useState(null);
  const [showAll, setShowAll] = useState(false);
  useEffect(() => { api.get("/admin/places/suggestions").then(({ data }) => setD(data)).catch(() => setD({ suggestions: [], new: 0 })); }, []);
  if (!d) return null;
  const setStatus = async (id, status) => {
    await api.put(`/admin/places/suggestions/${id}`, { status });
    setD((x) => ({ ...x, suggestions: x.suggestions.map((s) => (s.id === id ? { ...s, status } : s)), new: x.suggestions.filter((s) => (s.id === id ? status : s.status) === "new").length }));
  };
  const list = showAll ? d.suggestions : d.suggestions.filter((s) => s.status !== "archived").slice(0, 8);
  return (
    <div className="bg-white rounded-3xl soft-shadow p-6 mb-6" data-testid="place-suggestions-card">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <h3 className="font-display font-bold text-[#19324A] inline-flex items-center gap-2"><MapPin className="w-4 h-4 text-[#A78BFA]" /> Place suggestions from the Pack {d.new > 0 && <span className="rounded-full bg-[#FF6B9D] text-white text-xs px-2 py-0.5" data-testid="place-suggestions-new">{d.new} new</span>}</h3>
        {d.suggestions.length > 8 && <button onClick={() => setShowAll((v) => !v)} className="text-xs font-semibold text-[#4CC9F0]" data-testid="place-suggestions-toggle">{showAll ? "Show recent" : `Show all ${d.suggestions.length}`}</button>}
      </div>
      {list.length === 0 ? <p className="text-sm text-[#19324A]/55 mt-3" data-testid="place-suggestions-empty">No suggestions yet — the form lives at the bottom of /adventures.</p> : (
        <ul className="mt-4 divide-y divide-[#19324A]/5" data-testid="place-suggestions-list">
          {list.map((s) => (
            <li key={s.id} className="py-3 flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4" data-testid={`place-suggestion-${s.id}`}>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-bold text-[#19324A]">{s.place_name}{s.suburb ? <span className="font-normal text-[#19324A]/55"> · {s.suburb}</span> : null}</p>
                <p className="text-sm text-[#19324A]/75 mt-0.5 whitespace-pre-line">{s.why}</p>
                <p className="text-xs text-[#19324A]/50 mt-1">{s.name} · <a href={`mailto:${s.email}`} className="underline">{s.email}</a>{s.link && <> · <a href={s.link} target="_blank" rel="noopener noreferrer" className="underline">{s.link.replace(/^https?:\/\//, "")}</a></>} · {new Date(s.created_at).toLocaleDateString("en-AU")}</p>
              </div>
              <select value={s.status} onChange={(e) => setStatus(s.id, e.target.value)} className={`rounded-full text-xs font-bold px-3 py-1.5 border-0 ${pill[s.status]}`} data-testid={`place-suggestion-status-${s.id}`}>
                {STATUSES.map((st) => <option key={st} value={st}>{st}</option>)}
              </select>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
